/**
 * Enhanced logging utility that wraps console methods with additional context
 */
export const logger = {
  log: (...args: unknown[]): void => {
    const timestamp = new Date().toISOString();
    console.log(`[${timestamp}]`, ...args);
  },

  error: (...args: unknown[]): void => {
    const timestamp = new Date().toISOString();
    console.error(`[${timestamp}]`, ...args);
  },

  warn: (...args: unknown[]): void => {
    const timestamp = new Date().toISOString();
    console.warn(`[${timestamp}]`, ...args);
  },

  info: (...args: unknown[]): void => {
    const timestamp = new Date().toISOString();
    console.info(`[${timestamp}]`, ...args);
  },

  debug: (...args: unknown[]): void => {
    const timestamp = new Date().toISOString();
    console.debug(`[${timestamp}]`, ...args);
  },
};
